export {
  container,
  textRevised,
} from "@components/suggestion-body/suggestion-body-autopilot/SuggestionBodyAutopilot.styles";
import {
  textPrimary,
  iconPrimary,
} from "@components/suggestion-body/suggestion-body-autopilot/SuggestionBodyAutopilot.styles";
import { headerBody } from "../TailoredDefragSummaryCard.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const borderBottom = headerBody.borderBottom;
export const text = {
  ...textPrimary,
};

export const reason = {
  ...textPrimary,
  color: greys.slate,
};

export const icon = {
  ...iconPrimary.style,
  color: colors.green.standard,
  marginTop: 2,
};

export const row = {
  display: "flex",
  alignItems: "flex-start",
};
